export const isItemNameReadOnly = status => status === 'edit';



// WEBPACK FOOTER //
// ./src/utils/costCenterDisplay.js